module.exports = __webpack_public_path__ + "img/horizontal_3_7_r_pp13_5010.8e917153.png";